import customGuestValidateEmail from 'integration/generated/custom/customGuestValidateEmail';
import {
	GuestEmailAvailability,
	GuestEmailAvailabilityRequest,
} from 'integration/generated/custom/data-contracts';
import { RequestParams } from 'integration/generated/custom/http-client';

export const guestValidateFetcher =
	(pub: boolean) =>
	async (
		storeId: string,
		data: GuestEmailAvailabilityRequest,
		params: RequestParams = {}
	): Promise<GuestEmailAvailability> => {
		const res = await customGuestValidateEmail(pub).guestValidateEmail(storeId, data, {}, params);
		return res;
	};

/**
 * Client-side React hook to know the availability of an email using SWR.
 *
 * @param options Optional SWR configuration.
 * @param guestEmail An object with the email and nickname, .
 * @returns Boolean availability value.
 */
export const validateGuestEmail = async (
	storeId: string,
	guestEmail: GuestEmailAvailabilityRequest,
	params: RequestParams = {}
) => {
	let availability = false;
	await guestValidateFetcher(true)(storeId, guestEmail, params)
		.then((re) => {
			if (re.emailAvailablity) availability = re.emailAvailablity;
		})
		.catch((e) => {
			console.log(e);
		});
	return availability;
};
